/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminthreads_Colcreatedat3Inputs */

const zh_adminthreads_colcreatedat3 = /** @type {(inputs: Adminthreads_Colcreatedat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建时间`)
};

const en_adminthreads_colcreatedat3 = /** @type {(inputs: Adminthreads_Colcreatedat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created At`)
};

const es_adminthreads_colcreatedat3 = /** @type {(inputs: Adminthreads_Colcreatedat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

/**
* | output |
* | --- |
* | "Created At" |
*
* @param {Adminthreads_Colcreatedat3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminthreads_colcreatedat3 = /** @type {((inputs?: Adminthreads_Colcreatedat3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminthreads_Colcreatedat3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminthreads_colcreatedat3(inputs)
	if (locale === "en") return en_adminthreads_colcreatedat3(inputs)
	return es_adminthreads_colcreatedat3(inputs)
});
export { adminthreads_colcreatedat3 as "adminThreads_colCreatedAt" }